import { useQuery, useMutation, useQueryClient } from '@tanstack/vue-query'
import { consentApi } from '@/api/endpoints/consent'
import type { ConsentInput, ConsentStatus } from '@/types'

const consentKeys = {
  all: ['consent'] as const,
  status: () => [...consentKeys.all, 'status'] as const,
}

export function useConsentStatus() {
  return useQuery({
    queryKey: consentKeys.status(),
    queryFn: async () => {
      const { data } = await consentApi.getStatus()
      return data.data as ConsentStatus
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
}

export function useReConsent() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (consents: ConsentInput[]) => {
      const { data } = await consentApi.reConsent(consents)
      return data
    },
    onSuccess: () => {
      queryClient.setQueryData(consentKeys.status(), (prev: ConsentStatus | undefined) => {
        if (prev) return { ...prev, requires_re_consent: false }
        return prev
      })
    },
  })
}
